// Decide se uma mensagem recebida deve tocar som / avisar no navegador.
// Sem silêncio, é exatamente o negado da regra antiga do NotificationsPopOver.
// Silenciar só para o aviso: a mensagem continua na lista e contando como não lida.
const shouldAlertMessage = ({
	data,
	currentTicketId,
	visibility,
	userId,
	showGroupNotification,
	isMuted,
}) => {
	const blocked =
		(data.message.ticketId === currentTicketId && visibility === "visible") ||
		(data.ticket.userId && data.ticket.userId !== userId) ||
		(data.ticket.isGroup &&
			data.ticket?.whatsapp?.groupAsTicket === "disabled" &&
			showGroupNotification === false);

	if (blocked) return false;

	// menção/resposta à conexão em grupo ainda avisa
	if (isMuted && isMuted(data.ticket.contactId) && !data.mentionsConnection) return false;

	return true;
};

export default shouldAlertMessage;
